import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase'

import Login from './components/pages/Login.vue'
import MyStories from './components/pages/MyStories.vue'
import Editor from './components/pages/Editor.vue'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/login',
            component: Login
        },
        {
            path: '/stories',
            component: MyStories,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/editor',
            component: Editor,
            meta: {
                requiresAuth: true,
            }
        },
        { path: '*', redirect: '/login' }
    ]
})

router.beforeEach((to, from, next) => {
    const requiresAuth  = to.matched.some(x => x.meta.requiresAuth)
    const currentUser = firebase.auth().currentUser

    if (requiresAuth && !currentUser) {
        next('/login')
    } else if (requiresAuth && currentUser) {
        next()
    } else {
        next()
    }
})

export default router
